import React from 'react';
import type { SignInProvider } from 'fym-shared/src/music24/signInMethods';
import { TypedMemo } from '../../../../common/types';

/** The Google "G", as on the sign-in page (`AuthSsoButtons`). */
const GoogleMark: React.FC = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M23 12.27c0-.78-.07-1.53-.2-2.27H12v4.51h6.16a5.27 5.27 0 0 1-2.28 3.46v2.88h3.69C21.7 18.86 23 15.85 23 12.27Z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.08 0 5.66-1.02 7.55-2.76l-3.69-2.88c-1.02.69-2.33 1.1-3.86 1.1-2.97 0-5.49-2.01-6.39-4.71H1.79v2.96A11.99 11.99 0 0 0 12 24Z"
    />
    <path fill="#FBBC05" d="M5.61 14.75a7.2 7.2 0 0 1 0-4.59V7.2H1.79a12 12 0 0 0 0 10.61l3.82-3.06Z" />
    <path
      fill="#EA4335"
      d="M12 4.74c1.68 0 3.18.58 4.36 1.71l3.27-3.27C17.66 1.18 15.08 0 12 0A11.99 11.99 0 0 0 1.79 7.2l3.82 2.96C6.51 6.75 9.03 4.74 12 4.74Z"
    />
  </svg>
);

/** The Apple logo, as on the sign-in page (`AuthSsoButtons`). */
const AppleMark: React.FC = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M17.05 12.54c-.02-2.07 1.69-3.06 1.77-3.11-.97-1.41-2.47-1.61-3-1.63-1.28-.13-2.5.75-3.15.75-.65 0-1.65-.73-2.71-.71-1.39.02-2.68.81-3.4 2.05-1.45 2.52-.37 6.25 1.04 8.29.69.99 1.51 2.11 2.58 2.07 1.04-.04 1.43-.67 2.69-.67 1.25 0 1.61.67 2.71.65 1.12-.02 1.83-1.01 2.51-2.01.79-1.15 1.12-2.27 1.14-2.33-.03-.01-2.18-.84-2.2-3.32Z" />
    <path d="M14.97 5.62c.57-.7.96-1.66.85-2.62-.82.03-1.83.55-2.43 1.24-.53.61-1 1.6-.87 2.54.92.07 1.86-.46 2.45-1.16Z" />
  </svg>
);

const SignInProviderMarkComponent: React.FC<{ provider: SignInProvider }> = ({ provider }) =>
  provider === 'apple' ? <AppleMark /> : <GoogleMark />;

export const SignInProviderMark = TypedMemo(SignInProviderMarkComponent);
